import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { BaseService } from './base.service';
import { Patient } from '../models/patient.model';
import { MetaData, MetaDataRaw } from '../models/meta-data.model';

@Injectable()
export class PatientService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async testAndNormalizePatientId(patientId: string): Promise<string> {
    return this.post('patient/testAndNormalizePatientId', { patientId: patientId } );
  }

  async testAndNormalizeVisitId(visitId: string): Promise<string> {
    return this.post('patient/testAndNormalizeVisitId', { visitId: visitId } );
  }

  async testAndNormalizeSiteId(visitId: string): Promise<string> {
    return this.post('patient/testAndNormalizeSiteId', { visitId: visitId } );
  }

  async getPatientIds(): Promise<Patient[]> {
    return this.get('patient/ids');
  }

  async getPatientMetaData(patientId: string): Promise<MetaDataRaw[]> {
    return this.get('patient/' + patientId + '/metaData');
  }

  async getPatient(patientId: string): Promise<Patient> {
    return this.get('patient/raw/' + patientId);
  }

  async getStudyIdsForPatientId(patientId: string): Promise<{ studyIds: string[], studyIdToPrefill: string }> {
    return this.get('studyIds/' + patientId);
  }

  async getAllStudyIds(): Promise<string[]> {
    return this.get('studyIds');
  }

  async updateSecondaryIds(patientId: string, ids: { patId2: string, patId3: string, patId4: string }): Promise<null> {
    return this.post(`patient/ids/${patientId}`, ids);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/patient.service.ts